"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiSlider = getMuiSlider;
var _constants = require("../../../constants");
function getMuiSlider() {
  return {
    styleOverrides: {
      root: function (_ref) {
        var theme = _ref.theme;
        return {
          '& .MuiSlider-rail': {
            borderRadius: 4,
            color: theme.palette.gray[200],
            height: 8,
            opacity: 1
          },
          '& .MuiSlider-thumb': {
            '&:before': {
              display: 'none'
            },
            '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
              backgroundColor: theme.palette.primary[50],
              boxShadow: 'inherit',
              height: 24,
              width: 24
            },
            backgroundColor: theme.palette.common.white,
            border: "1.5px solid ".concat(theme.palette.primary[600]),
            boxShadow: theme.shadows[_constants.SHADOWS.md],
            height: 24,
            width: 24
          },
          '& .MuiSlider-track': {
            border: 'none'
          },
          '& .MuiSlider-valueLabel': {
            background: 'unset',
            backgroundColor: theme.palette.common.white,
            borderRadius: 8,
            boxShadow: '0px 4px 6px -2px rgba(18, 25, 38, 0.03), 0px 12px 16px -4px rgba(18, 25, 38, 0.08)',
            color: 'black',
            fontSize: 12,
            height: 40,
            lineHeight: 1.2,
            padding: 0,
            transformOrigin: 'bottom left',
            width: 40
          },
          '&.Mui-disabled': {
            '& .MuiSlider-thumb': {
              backgroundColor: theme.palette.gray[100],
              border: "1.5px solid ".concat(theme.palette.gray[300]),
              borderRadius: '12px',
              boxShadow: theme.shadows[_constants.SHADOWS.md]
            },
            '& .MuiSlider-track': {
              borderRadius: '4px',
              color: theme.palette.gray[300]
            }
          },
          borderRadius: 4,
          color: theme.palette.primary[600],
          height: 8
        };
      }
    }
  };
}